import { Box, CircularProgress } from '@mui/material';
import * as React from 'react';
import { ComponentProps, PropsWithChildren } from 'react';

type Color = ComponentProps<typeof CircularProgress>['color'];

type Props = {
  thickness?: number,
  color: Color,
  value: number,
  size?: number,
  labelSize?: number
}

export function CircularProgressWithLabel({size, value, color, thickness = 3, children}: PropsWithChildren<Props>) {
  return <Box sx={{position: 'relative', height: size, width: size}}>
    <CircularProgress variant="determinate" thickness={thickness}
                      color={color}
                      sx={{position: 'absolute',  opacity: .2}}
                      size={size} value={100} />
      <CircularProgress variant="determinate" size={size} value={value} color={color} thickness={thickness} />
    <Box
      sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        ':hover': {backgroundColor: 'rgba(0,0,0,0.06)'},
      }}
    >
      {children}
    </Box>
  </Box>
}
